import React from 'react';
import Header from '../Components/Header';
import './Styles/StaticPage.css';

const ContactUsPage: React.FC = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for your message! We will get back to you shortly.');
    // In a real app, you would handle form submission here (e.g., API call)
  };

  return (
    <div className="page-container">
      <Header />
      <main className="static-content">
        <div className="content-wrapper">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-intro">
            Have a question, feedback, or a partnership inquiry? We'd love to hear from you. Fill out the form below or reach out to us via email.
          </p>

          <div className="contact-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows={6} required></textarea>
              </div>
              <button type="submit" className="btn primary form-submit-btn">Send Message</button>
            </form>
            <div className="contact-info">
              <h3>Contact Information</h3>
              <p>For general inquiries, please email us. We strive to respond to all messages within 24-48 hours.</p>
              <ul>
                <li><strong>Email:</strong> support@hameruha.com</li>
                <li><strong>Address:</strong> 123 Learning Lane, Knowledge City, 45678</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContactUsPage;